"use client";

import React from "react";
import EditSection from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input } from "rizzui";
import { PiPlusBold, PiTrash, PiImage, PiUploadSimple } from "react-icons/pi";

export default function EducaeetCategoriesEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  const categories = content.categories || [
    { title: "Development", subtext: "120 Courses", bgImage: "" },
    { title: "Graphic Design", subtext: "85 Courses", bgImage: "" },
    { title: "Business", subtext: "95 Courses", bgImage: "" },
    { title: "Marketing", subtext: "75 Courses", bgImage: "" },
    { title: "Photography", subtext: "60 Courses", bgImage: "" },
    { title: "Music", subtext: "45 Courses", bgImage: "" },
    { title: "Data Science", subtext: "110 Courses", bgImage: "" },
    { title: "Cybersecurity", subtext: "90 Courses", bgImage: "" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="flex items-center justify-between mb-2">
            <label className="text-xs font-bold text-gray-800 uppercase tracking-wide">
              Course Categories
            </label>
            <button
              onClick={() => {
                updateContent("categories", [
                  ...categories,
                  { title: "New Category", subtext: "0 Courses", bgImage: "" }
                ]);
              }}
              className="text-xs text-blue-600 hover:text-blue-700 font-semibold flex items-center gap-1"
            >
              <PiPlusBold className="w-3 h-3" /> Add Category
            </button>
          </div>

          <div className="space-y-3 max-h-[350px] overflow-y-auto pr-1">
            {categories.map((category: any, idx: number) => (
              <div key={idx} className="bg-white p-3 rounded-lg border border-gray-200 space-y-2.5 relative shadow-xs">
                <div className="flex items-center justify-between">
                  <span className="text-[10px] font-bold text-emerald-800 uppercase tracking-wide">Category {idx + 1}</span>
                  <button
                    onClick={() => {
                      const updated = categories.filter((_: any, i: number) => i !== idx);
                      updateContent("categories", updated);
                    }}
                    className="p-1 text-gray-400 hover:text-red-500 rounded hover:bg-red-50"
                    title="Delete Category"
                  >
                    <PiTrash className="w-4 h-4" />
                  </button>
                </div>

                {/* Image Upload / Input */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-md bg-gray-100 border border-gray-200 overflow-hidden flex items-center justify-center shrink-0">
                    {category.bgImage ? (
                      <img src={category.bgImage} alt="Preview" className="w-full h-full object-cover" />
                    ) : (
                      <PiImage className="w-5 h-5 text-gray-400" />
                    )}
                  </div>
                  <label className="flex items-center justify-center gap-1.5 py-1.5 px-3 bg-slate-50 border border-dashed border-gray-300 rounded text-[11px] font-semibold text-gray-700 hover:bg-slate-100 cursor-pointer transition-all flex-1">
                    <PiUploadSimple className="w-3.5 h-3.5 text-gray-500" />
                    <span>Change Image</span>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onload = (uploadEvent) => {
                            const updated = [...categories];
                            updated[idx] = { ...category, bgImage: uploadEvent.target?.result as string };
                            updateContent("categories", updated);
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                  </label>
                </div>

                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Title</label>
                    <Input
                      value={category.title || ""}
                      onChange={(e) => {
                        const updated = [...categories];
                        updated[idx] = { ...category, title: e.target.value };
                        updateContent("categories", updated);
                      }}
                      className="!rounded-md text-xs"
                      placeholder="Development"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wide mb-1 block">Subtext / Courses</label>
                    <Input
                      value={category.subtext || ""}
                      onChange={(e) => {
                        const updated = [...categories];
                        updated[idx] = { ...category, subtext: e.target.value };
                        updateContent("categories", updated);
                      }}
                      className="!rounded-md text-xs"
                      placeholder="120 Courses"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      }
    />
  );
}
